import { render, staticRenderFns } from "./SettingsTournamentCurrency.vue?vue&type=template&id=52a5d5f4&"
import script from "./SettingsTournamentCurrency.vue?vue&type=script&lang=js&"
export * from "./SettingsTournamentCurrency.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTournamentCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports